import { useState } from "react";

export const useUniModalPortableContainer = () => {
  const [uniModalPortableContent, setUniModalPortableContent] = useState(false); // false or modalContent { options: {}, jsx: (<></>)}

  const setUniModalPortableClose = () => { setUniModalPortableContent(false) };

  const uniModalPortableContainerPack = {
    uniModalPortableContent,
    setUniModalPortableContent,
    setUniModalPortableClose,
  };
  return {
    setUniModalPortableContent,
    setUniModalPortableClose,
    uniModalPortableContainerPack,
  };
};